import { SELECT_ELEMENT, UNSELECT_ELEMENT, UNSELECT_ALL, SELECT_ELEMENTS, ADD_FILTER, REMOVE_FILTER, RESET_FILTERS, ADD_FILTERS, TEASER_SHOWN } from "../../actions";
import { modelService } from '../../../services/model';
import _ from 'lodash';

const capabilitySpecificationSeparator = ' [';
const MAX_TEASERS_PER_SESSION = 3;
const MIN_TIME_BETWEEN_TEASERS_MS = 12*1000;
export default function (selectedElements, filters, oldTeaserInfo, action) {
    var teaserInfo = {
        nextTeaser: undefined,
        alreadyShown: [...oldTeaserInfo.alreadyShown],
        timeNextTeaserToShow: oldTeaserInfo.timeNextTeaserToShow
    }
    switch (action.type) {
      case SELECT_ELEMENT:
      case SELECT_ELEMENTS:
      case UNSELECT_ELEMENT:
      case UNSELECT_ALL:
      case ADD_FILTER:
      case ADD_FILTERS:
      case REMOVE_FILTER:
      case RESET_FILTERS:
        if(selectedElements.length > 0 && teaserInfo.alreadyShown.length < MAX_TEASERS_PER_SESSION){
            const selectedIds = selectedElements.map(element => element.id);
            const selectedComponents = modelService.getAllComponents().filter(comp => selectedIds.includes(comp.id));
            var validTeasers = modelService.getAllTeasers().filter(teaser => evaluateCondition(teaser.cond, selectedComponents, filters));
            validTeasers = validTeasers.filter(teaser => !oldTeaserInfo.alreadyShown.includes(teaser.id));
            if(validTeasers !== undefined && validTeasers.length > 0){
                const randIndex = Math.floor(Math.random() * validTeasers.length);
                teaserInfo.nextTeaser = validTeasers[randIndex];           
                teaserInfo.timeNextTeaserToShow = Math.max(Date.now(),oldTeaserInfo.timeNextTeaserToShow + MIN_TIME_BETWEEN_TEASERS_MS);
            }
        }
        break;
      case TEASER_SHOWN:
        teaserInfo.alreadyShown = [...teaserInfo.alreadyShown, action.teaserId];
        break;
      default:
        break;
    }
    return teaserInfo;
  }

function evaluateCondition(condition, selectedComponents, filters) {
    var evaluationResult = true;
    if(condition.and !== undefined && Array.isArray(condition.and)){
        evaluationResult = true;
        _.forEach(condition.and, operand => {
            evaluationResult = evaluationResult && evaluateCondition(operand, selectedComponents, filters);
        });
        return evaluationResult;
    } else if(condition.or !== undefined && Array.isArray(condition.or)){
        evaluationResult = false;
        _.forEach(condition.or, operand => {
            evaluationResult = evaluationResult || evaluateCondition(operand, selectedComponents, filters);
        });
        return evaluationResult;
    } else if(condition.minLandscapeSize !== undefined){
        return selectedComponents.length >= condition.minLandscapeSize;
    } else if(condition.component !== undefined){
        return checkComponents(condition.component,selectedComponents);
    } else if(condition.filter !== undefined){
        return checkFilters(condition.filter,filters);
    }   
}

function checkComponents(compCondition, components) {
    return components.findIndex(comp => contains(comp, compCondition)) >= 0;
}

function contains(element,fragment) {
    if(fragment.constructor === Object && element.constructor === Object){
        for(var key in fragment){
            if(element[key] === undefined){
                return false;
            }
            if(!contains(element[key],fragment[key])){
                return false;
            }
        }
        return true;
    } else if(fragment.constructor === Array && element.constructor === Array){
        return fragment.reduce((allContained, fragItem) => {
            return allContained && (element.findIndex(item => contains(item, fragItem)) >= 0);
        }, true);
    } else if(typeof fragment === "string" && typeof element === "string"){
        return element.startsWith(fragment);
    } else {
        return fragment === element;
    } 
}

function checkFilters(condFilter, filters){
    return filters.findIndex(filter => checkFilter(filter, condFilter)) >= 0;
}

function checkFilter(condFilter, filter){
    const condSeparatorIdx = condFilter.value.indexOf(capabilitySpecificationSeparator)
    const condValue = condSeparatorIdx >= 0 ? condFilter.value.substring(0, condSeparatorIdx):condFilter.value;
    const filterSeparatorIdx = filter.value.indexOf(capabilitySpecificationSeparator)
    const filterValue = filterSeparatorIdx >= 0 ? filter.value.substring(0, filterSeparatorIdx):filter.value;

    return condFilter.capability === filter.capability && condValue === filterValue;
}


// WEBPACK FOOTER //
// ./src/redux/reducers/teasers/index.js